// extracted by mini-css-extract-plugin
export default {"footerContainer":"SSj5B40uOASRDX9Vazk5","contentContainer":"pDrEAFNVCpTUM7VBPBD_","moreActionsPopup":"NkGKsKiog6BqNclrZm6a"};